export const obtenerUrlAPIPagos = (uri) => {
  return `${process.env.VUE_APP_URL_API_PAGOS}${uri}`;
};

export const dividirPorResta = (dividendo, divisor, precision = 2) => {
  if (divisor === 0) return null;
  let sign = 1;
  if (dividendo < 0) {
    sign *= -1;
    dividendo = Math.abs(dividendo);
  }
  if (divisor < 0) {
    sign *= -1;
    divisor = Math.abs(divisor);
  }

  let entero = 0;
  while (dividendo >= divisor) {
    dividendo -= divisor;
    entero++;
  }

  const digitos = [];
  for (let i = 0; i < precision; i++) {
    dividendo *= 10;
    let dig = 0;
    while (dividendo >= divisor) {
      dividendo -= divisor;
      dig++;
    }
    digitos.push(dig);
  }

  const frac = digitos.reduce((acc, d, idx) => acc + d / Math.pow(10, idx + 1), 0);

  return Number(sign * (entero + frac));
};

export const formatearNumeroAMoneda = (numero, decimales = 2) => {
  if (numero === null || numero === undefined || isNaN(numero)) {
    return '';
  }

  const num = parseFloat(numero);
  const fixed = num.toFixed(decimales);
  const [entero, decimal] = fixed.split('.');

  const enteroFormateado = entero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return decimales > 0 ? `${enteroFormateado},${decimal}` : enteroFormateado;
};
